/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingAnalytics_listing$ref: FragmentReference;
declare export opaque type AggregatesListingAnalytics_listing$fragmentType: AggregatesListingAnalytics_listing$ref;
export type AggregatesListingAnalytics_listing = {|
  +id: string,
  +encodedId: string,
  +slug: string,
  +offerType: OfferType,
  +propertyType: ?string,
  +compositePropertyType: CompositePropertyType,
  +numberOfRooms: ?number,
  +numberOfBathrooms: ?number,
  +livingSurface: ?number,
  +landSurface: ?number,
  +salePrice: ?number,
  +grossRentMonthly: ?number,
  +currency: ?string,
  +constructionYear: ?number,
  +locality: ?string,
  +propertyMainType: ?string,
  +stateObject: ?{|
    +label: string
  |},
  +municipalityObject: ?{|
    +label: string
  |},
  +streetNumber: ?string,
  +route: ?string,
  +postcode: ?string,
  +lat: ?number,
  +lng: ?number,
  +agencyName: ?string,
  +agencyReference: ?string,
  +lotReference: ?string,
  +$refType: AggregatesListingAnalytics_listing$ref,
|};
export type AggregatesListingAnalytics_listing$data = AggregatesListingAnalytics_listing;
export type AggregatesListingAnalytics_listing$key = {
  +$data?: AggregatesListingAnalytics_listing$data,
  +$fragmentRefs: AggregatesListingAnalytics_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingAnalytics_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "encodedId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositePropertyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfRooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfBathrooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "livingSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossRentMonthly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "constructionYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locality",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyMainType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "stateObject",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "municipalityObject",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streetNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "route",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postcode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lotReference",
      "storageKey": null
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '0d5b668a7b877af0c8ba31489e11f8d4';

export default node;
